<template lang="pug">
  v-sheet(
    :color="darkBg ? 'grey lighten-4' : undefined"
    :min-height="!!sectionComponent ? 600 : null"
  ).generic-section.d-flex.align-center
    CC-section-actions(
      v-if="!readonly"
      :first="first"
      :last="last"
      :can-delete-first="!!sectionComponent"
      @move:after="$emit('move:after')"
      @move:before="$emit('move:before')"
      @remove="$emit('remove')"
      @add:after="$emit('add:after')"
      @add:before="$emit('add:before')"
    )
    v-container.py-10.px-md-15
      .d-flex.justify-center
        v-sheet(
          color="transparent"
          max-width=950
        ).fill-width
          CC-input(
            v-model="value.title"
            :readonly="readonly"
            :placeholder="course ? null : 'Добавьте заголовок'"
            :class="!!sectionComponent ? 'text-center' : null"
          ).text-h4.font-weight-bold
          CC-input(
            v-model="value.description"
            :readonly="readonly"
            :placeholder="course ? 'Добавьте описание, если необходимо...' : 'Добавьте описание'"
            :class="!!sectionComponent ? 'text-center grey--text' : null"
          ).my-2
      component(
        v-if="sectionComponent"
        :is="sectionComponent"
        :course="course"
        :cards-values.sync="cards"
        :readonly="readonly"
        @update:cards="setCards"
      )
</template>

<script>
import CCInput from './CCInput.vue';
import CCSectionActions from './CCSectionActions.vue';
import CCGenericSection from './CCSectionGeneric.vue';
import CCSectionUnits from './CCSectionUnits.vue';

import { SECTION_TYPES } from './constants';

const ALIASES = {
  [SECTION_TYPES.generic]: CCGenericSection,
  [SECTION_TYPES.units]: CCSectionUnits,
};

export default {
  components: {
    CCSectionActions,
    CCInput,
  },
  props: {
    value: { type: Object, required: true },
    course: { type: Object, default: () => {} },
    cardsType: { type: Number, default: null },
    darkBg: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
    first: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({
    cards: [],

    SECTION_TYPES,
  }),
  computed: {
    sectionComponent() {
      return ALIASES[this.value.type];
    },
  },
  created() {
    this.cards = [...(this.value.cards || [])];
  },
  methods: {
    setCards(val) {
      this.cards = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.generic-section {
  position: relative;

  &:hover {
    .generic-section__controllers {
      opacity: 1;
    }
  }

  &__controllers {
    position: sticky;
    width: 80px;
    top: 50px;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    transition: opacity .3s;
    z-index: 1;
  }
}
</style>
